import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE } from '../api-base.token';
import { FeatureToggleResponse } from './feature-toggle-response';

const path = 'feature-toggles';

@Injectable({
  providedIn: 'root',
})
export class FeatureTogglesHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, `${path}`);

    return this.httpClient.get<FeatureToggleResponse[]>(url);
  }

  update(id: string, isEnabled: boolean) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${id}`);

    return this.httpClient.put(url, { isEnabled });
  }
}